import { handleFormErrors, clearFormErrors, fetchWithErrors } from './errorHandler';

// Form selectors for different onboarding steps
const FORM_SELECTORS = {
  registration: '.registration-form',
  profileInfo: '[data-form="profile-info"]',
  interests: '[data-form="interests"]',
  photos: '[data-form="photos"]'
};

// Initialize form handlers for all onboarding forms
export const initializeFormHandlers = () => {
  // Registration form handling
  const registrationForm = document.querySelector(FORM_SELECTORS.registration);
  if (registrationForm) {
    setupFormValidation(registrationForm, {
      onSuccess: (response) => {
        if (response.redirect_url) {
          window.location.href = response.redirect_url;
        }
      }
    });
  }

  // Profile info form handling
  const profileForm = document.querySelector(FORM_SELECTORS.profileInfo);
  if (profileForm) {
    setupFormValidation(profileForm, {
      onSuccess: (response) => {
        if (response.redirect_url) {
          window.location.href = response.redirect_url;
        }
      }
    });
  }

  // Interests form handling
  const interestsForm = document.querySelector(FORM_SELECTORS.interests);
  if (interestsForm) {
    setupFormValidation(interestsForm, {
      onSuccess: (response) => {
        if (response.redirect_url) {
          window.location.href = response.redirect_url;
        }
      }
    });
  }

  // Photos form handling
  const photosForm = document.querySelector(FORM_SELECTORS.photos);
  if (photosForm) {
    setupFormValidation(photosForm, {
      onSuccess: (response) => {
        if (response.redirect_url) {
          window.location.href = response.redirect_url;
        }
        // Handle photo upload success (e.g., show preview)
        if (response.photo) {
          updatePhotoPreview(response.photo);
        }
      }
    });
  }
};

// Set up form validation and submission handling
const setupFormValidation = (form, { onSuccess }) => {
  // Guard against double-binding: initializeFormHandlers re-runs on Turbo
  // navigations (see application.js), and the same form node can be visited
  // more than once. Without this, a submit would fire multiple fetches.
  if (form.dataset.handlerAttached === 'true') return;
  form.dataset.handlerAttached = 'true';

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    
    // Clear any existing errors
    clearFormErrors(form);
    
    try {
      const formData = new FormData(form);
      const method = form.querySelector('input[name="_method"]')?.value || form.method;
      
      // Add CSRF token to FormData if it's not already there
      if (!formData.has('authenticity_token')) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
        if (csrfToken) {
          formData.append('authenticity_token', csrfToken);
        }
      }

      const response = await fetchWithErrors(form.action, {
        method: method.toUpperCase(),
        body: formData
      });
      
      if (response.success) {
        // Show success message if provided
        if (response.message) {
          showSuccessMessage(form, response.message);
        }
        
        // Call success callback
        onSuccess(response);
      }
    } catch (errors) {
      handleFormErrors(errors, form);
    }
  });
};

// Show success message
const showSuccessMessage = (form, message) => {
  const successDiv = document.createElement('div');
  successDiv.className = 'success-message bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4';
  successDiv.textContent = message;
  form.insertBefore(successDiv, form.firstChild);
};

// Update photo preview after successful upload
const updatePhotoPreview = (photo) => {
  const previewContainer = document.querySelector('.photo-preview');
  if (previewContainer) {
    const img = document.createElement('img');
    img.src = photo.url;
    img.alt = 'Uploaded photo';
    img.className = 'uploaded-photo';
    img.dataset.photoId = photo.id;
    
    if (photo.primary) {
      img.classList.add('primary-photo');
    }
    
    previewContainer.appendChild(img);
  }
};
